import { api } from '../../http';
import { TagType, TaskClosingCode } from '../../types/interfaces';

import Api from './api';
import IClosingCodesApi from './interfaces/closingCodesApi';

class ClosingCodesApi extends Api<TaskClosingCode> implements IClosingCodesApi {
  constructor(abortController: AbortController) {
    super('closingCode/', abortController);
  }

  async getByStatus(statusId: number) {
    const apiCallResult = await api.get<TaskClosingCode[]>(
      `closingCode/getByStatus?id=${statusId}`,
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }

  async getForSelection() {
    const apiCallResult = await api.get<TagType[] | undefined>(
      'closingCode/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }

  async restore(id: number) {
    await api.get('closingCode/restore?id=' + id, {
      signal: this._abortController.signal
    });
  }

  async addOrUpdateWithError(
    model: TaskClosingCode
  ): Promise<number | string | undefined> {
    const apiCallResult = await api.post('closingCode/', model, {
      signal: this._abortController.signal
    });
    return (typeof apiCallResult.data === 'number' ||
      typeof apiCallResult.data === 'string') &&
      apiCallResult?.data
      ? apiCallResult.data
      : undefined;
  }
}

export default ClosingCodesApi;
